<template>
  <!-- 路由匹配的组件会在这里渲染 -->
  <router-view />
</template>

<script setup lang="ts">
// 这里不需要写任何内容
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased; /* 让字体更清晰 */
  background-color: #f5f7fa; /* 商城常用的浅灰背景色 */
}

a {
  text-decoration: none;
  color: inherit;
}
</style>